import { AnalyticsServiceProvider } from '../analytics-service/analytics-service';
import { App, Platform } from 'ionic-angular';
import { AuthenticationServiceProvider } from '../authentication-service/authentication-service';
import { DataUpdateServiceProvider } from '../data-update-service/data-update-service';
import { Injectable } from '@angular/core';
import { PlayerServiceProvider } from '../player-service/player-service';

@Injectable()
export class LifeCycleServiceProvider {
  constructor(
    private analyticsService: AnalyticsServiceProvider,
    private app: App,
    private authenticationService: AuthenticationServiceProvider,
    private dataUpdateService: DataUpdateServiceProvider,
    private platform: Platform,
    private playerService: PlayerServiceProvider,
  ) {}

  onDeviceReady() {
    this.authenticationService
      .validateTokens()
      .then(() => this.app.getRootNav().setRoot('LoadingPage', {}, { animate: true }))
      .catch(() => this.app.getActiveNavs()[0].setRoot('LoginPage'));

    this.analyticsService.sendAnalytics('Start');
  }

  onPause() {
    this.playerService
      .getPlayer()
      .then((player) => this.analyticsService.sendScreenData(player))
      .catch(() => this.analyticsService.sendScreenData('getPlayerError'));
  }

  initializeEventListeners() {
    this.platform.pause.subscribe(() => {
      this.onPause();
    });
    this.platform.ready().then(() => this.onDeviceReady());
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/services/life-cycle-service/life-cycle-service.ts